import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import CloseIcon from '@mui/icons-material/Close';
import { styled } from '@mui/material/styles';

import MDTypography from 'components/MDTypography';

// Centrer le titre avec du style personnalisé
const CenteredDialogTitle = styled(DialogTitle)(({ theme }) => ({
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '1.2rem',
    textTransform: 'uppercase',
}));

// Réduction du padding pour un body plus compact
const CompactDialogContent = styled(DialogContent)(({ theme }) => ({
    padding: theme.spacing(1, 3),
    textAlign: 'center',
}));

function MDPopup({
    open,
    onClose,
    onConfirm,
    item,
    title = "Confirm Action",
    body = "Are you sure you want to proceed?",
    confirmLabel = "Confirm",
    cancelLabel = "Cancel",
    showConfirmButton = true,
    showCancelButton = true
}) {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <CenteredDialogTitle sx={{ position: 'relative' }}>
                {title}
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            </CenteredDialogTitle>
            <CompactDialogContent>
                <MDTypography variant="body2">
                    {typeof body === 'function' ? body(item) : body}
                </MDTypography>
            </CompactDialogContent>
            <DialogActions sx={{ justifyContent: 'center', paddingBottom: 2 }}>
                {showCancelButton && (
                    <Button onClick={onClose} color="white" variant="contained"> {cancelLabel} </Button>
                )}
                {showConfirmButton && (
                    <Button onClick={onConfirm} color="white" variant="contained" sx={{ color: 'dark.main' }}> {confirmLabel} </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}

export default MDPopup;
